import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2LinkIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 16.412 12.707",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 16.412),
    children: [/*#__PURE__*/jsx("path", {
      d: "m6.254 10.756-.6.6a2.9 2.9 0 1 1 -4.1-4.1l3.075-3.072a2.9 2.9 0 0 1 4.4 3.752"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.276 2.038.483-.483a2.9 2.9 0 0 1 4.1 4.1l-3.075 3.073a2.9 2.9 0 0 1 -4.4-3.752"
    })]
  });
};

export { PM2LinkIcon };
//# sourceMappingURL=link.js.map
